import { images } from '../constants'; 

const cars = [
    {
        id: 1,
        name: 'Toyota Camry',
        image: images.car1Gallery1,
        price: 55,
        gallery: {
            image1: images.car1Gallery1,
            image2: images.car1Gallery2,
            image3: images.car1Gallery3,
            image4: images.car1Gallery4,
        }, 
        details: {
            year: 2022,
            brand: "Toyota",
            type: "Sedan",
            fuelType: ["Petrol", "Hybrid"],
            transmission: ["Automatic", "Manual"],
            costPerMile: "$1.8 per mile",
            availability: "All days",
            maxSpeed: "135 mph",
            power: "203 HP",
            range: "450 miles",
            climateControl: "Dual-Zone Climate Control",
            safetyFeatures: "Airbags, ABS, Lane Assist",
            colorOptions: "Silver, White, Blue",
            seats: "5 seats",
            suitcase: "2 suitcase",
        },
        description: 'The Toyota Camry blends performance, efficiency, and modern design into one refined sedan. It features a responsive 2.5L engine paired with a smooth 8-speed transmission, delivering both power and comfort. Inside, passengers enjoy a quiet cabin with premium materials and user-friendly tech, including advanced driver-assist features. Ideal for both business and leisure trips, the Camry offers a balanced ride every time you hit the road.',
        additionalInfo: [
            '203 Horsepower',
            '8-Speed Automatic Transmission',
            'Front-Wheel Drive',
            'Toyota Safety Sense',
            'Heated Front Seats',
            'Touchscreen Infotainment System',
        ],
        comments: [
            {
                id: 1,
                image: images.car1Review1,
                name: 'Daniel Scott',
                date: 'Feb 15th, 2023',
                rating: 4.7,
                content: 'Comfortable and efficient! Loved the ride and how smooth it handled city traffic and highways.',
            },
            {
                id: 2,
                image: images.car1Review2,
                name: 'Emily Johnson',
                date: 'July 8th, 2023',
                rating: 4.6,
                content: 'Excellent features and great value. The hybrid option helped me save on fuel during my trip!',
            },
        ]
    },
    {
        id: 2,
        name: 'BMW Z4',
        image: images.car2Gallery1,
        price: 120,
        gallery: {
            image1: images.car2Gallery1,
            image2: images.car2Gallery2,
            image3: images.car2Gallery3,
            image4: images.car2Gallery4,
        },
        details: {
            year: 2023,
            brand: "BMW",
            type: "Convertible",
            fuelType: ["Petrol"],
            transmission: ["Automatic"],
            costPerMile: "$2.5 per mile",
            availability: "All days",
            maxSpeed: "155 mph",
            power: "382 HP",
            range: "350 miles",
            climateControl: "Automatic Climate Control",
            safetyFeatures: "Airbags, ABS, Dynamic Stability Control",
            colorOptions: "Black, White, Red, Blue",
            seats: "2 seats",
            suitcase: "1 suitcase",
        },
        description: 'The BMW Z4 is a thrilling roadster that combines exhilarating performance with open-top freedom. Its turbocharged 3.0L inline-6 engine delivers 382 horsepower, propelling you from 0-60 mph in just 3.9 seconds. The retractable hardtop transforms in seconds, offering the perfect balance of coupe-like refinement and wind-in-your-hair excitement. Premium materials and cutting-edge technology create a driver-focused cockpit that enhances every journey.',
        additionalInfo: [
            '382 Horsepower TwinPower Turbo Engine',
            '8-Speed Sport Automatic Transmission',
            'Rear-Wheel Drive',
            'M Sport Package Available',
            'Heated Seats',
            '12.3" Digital Instrument Cluster',
            '10.25" Touchscreen with iDrive 7',
            'Harmon Kardon Premium Sound System',
        ],
        comments: [
            {
                id: 1,
                image: images.car2Review1,
                name: 'Michael Roberts',
                date: 'June 20th, 2023',
                rating: 4.9,
                content: 'Absolute dream to drive! The acceleration is breathtaking and the handling is razor-sharp. Perfect weekend car.',
            },
            {
                id: 2,
                image: images.car2Review2,
                name: 'Sarah Williams',
                date: 'August 12th, 2023',
                rating: 4.8,
                content: 'The perfect balance of luxury and performance. Dropping the top on coastal roads was an unforgettable experience.',
            },
        ]
    },
    {
        id: 3,
        name: 'BMW X5',
        image: images.car3Gallery1,
        price: 95,
        gallery: {
            image1: images.car3Gallery1,
            image2: images.car3Gallery2,
            image3: images.car3Gallery3,
            image4: images.car3Gallery4,
        },
        details: {
            year: 2024,
            brand: "BMW",
            type: "SUV",
            fuelType: ["Petrol", "Diesel", "Hybrid"],
            transmission: ["Automatic"],
            costPerMile: "$2.2 per mile",
            availability: "All days",
            maxSpeed: "130 mph",
            power: "335 HP",
            range: "450 miles+",
            climateControl: "4-Zone",
            safetyFeatures: "Airbags, ABS, Lane Assist, Sensors",
            colorOptions: "Black, White, Gray, Blue, Metallic",
            seats: "5 seats",
            suitcase: "4 large suitcases",
        },
        description: 'The BMW X5 redefines luxury SUV performance with its powerful engine options, spacious premium interior, and advanced technology. The xDrive all-wheel drive system ensures confident handling in all conditions, while the available third row makes it versatile for families. Features like the panoramic sunroof, Vernasca leather seats, and BMW Live Cockpit Professional create an exceptional driving experience whether navigating city streets or embarking on road trips.',
        additionalInfo: [
            '3.0L Turbocharged I6 Engine (xDrive40i)',
            '8-Speed Sport Automatic Transmission',
            'xDrive Intelligent All-Wheel Drive',
            'Adaptive Air Suspension Available',
            'Heated/Ventilated Front Seats',
            '12.3" Digital Instrument Cluster + 14.9" Touchscreen',
            'Harman Kardon Surround Sound System',
            'Wireless Apple CarPlay/Android Auto',
            'Hands-free Power Tailgate',
        ],
        comments: [
            {
                id: 1,
                image: images.car3Review1,
                name: 'James Wilson',
                date: 'March 10th, 2023',
                rating: 4.8,
                content: 'Perfect family SUV that doesn’t compromise on luxury. The plug-in hybrid version gave us incredible mileage on our summer vacation.',
            },
            {
                id: 2,
                image: images.car3Review2,
                name: 'Olivia Chen',
                date: 'September 5th, 2023',
                rating: 4.9,
                content: 'The X5 handles like a much smaller car – unbelievable for an SUV. The interior quality is exceptional and the tech interface is intuitive.',
            }
        ]
    },
    {
        id: 4,
        name: 'Volkswagen Golf',
        image: images.car4Gallery1,
        price: 45,
        gallery: {
            image1: images.car4Gallery1,
            image2: images.car4Gallery2,
            image3: images.car4Gallery3,
            image4: images.car4Gallery4,
        },
        details: {
            year: 2025,
            brand: "Volkswagen",
            type: "Hatchback",
            fuelType: ["Petrol", "Diesel", "Electric"],
            transmission: ["Automatic", "Manual"],
            costPerMile: "$1.5 per mile",
            availability: "All days",
            maxSpeed: "130 mph (varies by engine)",
            power: "147 HP (TSI model)",
            range: "450 miles (Petrol), 550 miles (Diesel)",
            climateControl: "Dual-Zone Automatic",
            safetyFeatures: "Airbags, ABS, ESC, Front Assist, Lane Assist",
            colorOptions: "White, Black, Gray, Blue, Red",
            seats: "5 seats",
            suitcase: "2 large suitcases",
        },
        description: 'The Volkswagen Golf sets the standard for compact hatchbacks with its perfect blend of practicality, efficiency, and German engineering. Known for its precise handling and high-quality interior, the Golf offers surprising space in a compact package. The turbocharged engines deliver peppy performance while maintaining excellent fuel economy. Ideal for city driving and weekend getaways alike, with available options ranging from fuel-efficient diesels to fully electric e-Golf models.',
        additionalInfo: [
            '1.5L TSI Turbocharged Engine (base model)',
            '6-Speed Manual or 8-Speed Automatic',
            'Front-Wheel Drive',
            'Digital Cockpit (available)',
            'Heated Front Seats',
            '8-inch Touchscreen Infotainment',
            'Apple CarPlay/Android Auto',
            'LED Headlights',
            'Keyless Entry (available)'
        ],
        comments: [
            {
                id: 1,
                image: images.car4Review1,
                name: 'Thomas Müller',
                date: 'April 18th, 2023',
                rating: 4.6,
                content: 'The perfect all-rounder! Comfortable for daily commutes yet fun on twisty roads. The hatchback is incredibly practical for its size.',
            },
            {
                id: 2,
                image: images.car4Review2,
                name: 'Sophie Laurent',
                date: 'November 3rd, 2023',
                rating: 4.5,
                content: 'Loved the fuel efficiency of the diesel version on my road trip. The interior feels premium despite being an affordable car.',
            }
        ]
    },
    {
        id: 5,
        name: 'Nissan GT-R',
        image: images.car5Gallery1,
        price: 250,
        gallery: {
            image1: images.car5Gallery1,
            image2: images.car5Gallery2,
            image3: images.car5Gallery3,
            image4: images.car5Gallery4,
        },
        details: {
            year: 2019,
            brand: "Nissan",
            type: "Sports Car",
            fuelType: ["Petrol"],
            transmission: ["Automatic"],
            costPerMile: "$4.0 per mile",
            availability: "Weekends only",
            maxSpeed: "196 mph",
            power: "565 HP",
            range: "280 miles",
            climateControl: "Dual-Zone",
            safetyFeatures: "VDC, 4-wheel steering, Brembo brakes",
            colorOptions: "Black, White, Gray, Purple",
            seats: "4 seats",
            suitcase: "2 large suitcase",
        },
        description: 'The Nissan GT-R "Godzilla" is a technological masterpiece that delivers supercar performance with Japanese precision. Its hand-built 3.8L twin-turbo V6 rockets from 0-60 mph in just 2.9 seconds, while the advanced ATTESA E-TS all-wheel drive system provides supernatural grip. The cockpit blends racing functionality with premium materials like semi-aniline leather and forged aluminum controls. This is a rare opportunity to experience one of the most legendary performance cars ever made.',
        additionalInfo: [
            '3.8L VR38DETT Twin-Turbo V6 Engine',
            '6-Speed GR6 Dual-Clutch Transmission',
            'Advanced ATTESA E-TS AWD System',
            '20" RAYS Forged Aluminum Wheels',
            'Recaro Performance Seats (Nismo package)',
            '11-speaker Bose Audio System',
            'Multifunction Display with Performance Telemetry',
            'Launch Control System',
            'Dry Carbon Fiber Rear Spoiler (Nismo)',
            'Titanium Exhaust (Nismo)'
        ],
        comments: [
            {
                id: 1,
                image: images.car5Review1,
                name: 'Takashi Yamamoto',
                date: 'May 22nd, 2023',
                rating: 5.0,
                content: 'Absolute beast! The acceleration pins you to the seat and the AWD gives unbelievable cornering grip. Worth every penny for a special occasion.',
            },
            {
                id: 2,
                image: images.car5Review2,
                name: 'Emma Rodriguez',
                date: 'August 15th, 2023',
                rating: 4.9,
                content: 'Drove this on my birthday - the sound of the turbo spooling is addictive! Surprisingly comfortable for a supercar. Staff warned me about speeding tickets!',
            }
        ],
    },
    {
        id: 6,
        name: 'Kia Carnival',
        image: images.car6Gallery1,
        price: 70,
        gallery: {
            image1: images.car6Gallery1,
            image2: images.car6Gallery2,
            image3: images.car6Gallery3,
            image4: images.car6Gallery4,
        },
        details: {
            year: 2020,
            brand: "Kia",
            type: "Minivan",
            fuelType: ["Petrol", "Diesel"],
            transmission: ["Automatic"],
            costPerMile: "$1.8 per mile",
            availability: "All days",
            maxSpeed: "115 mph",
            power: "290 HP",
            range: "420 miles",
            climateControl: "Tri-Zone Automatic",
            safetyFeatures: "7 Airbags, Cruise Control",
            colorOptions: "Graphite, White, Silver, Black",
            seats: "7-8 seats",
            suitcase: "6-8 suitcases",
        },
        description: 'The Kia Carnival redefines family travel with SUV-like styling and premium minivan functionality. Its spacious interior features available VIP lounge second-row seats with leg extensions, while the 3.5L V6 delivers smooth power for fully-loaded trips. The innovative "Theater Mode" raises second-row seats for better views, and dual sliding doors make child seat access effortless. Packed with family-friendly tech like rear seat entertainment and quiet cabin insulation, this is the ultimate road trip vehicle.',
        additionalInfo: [
            '3.5L MPi V6 Engine (290HP/262 lb-ft)',
            '8-Speed Automatic Transmission',
            'Front-Wheel Drive',
            '12.3" Touchscreen w/ Navigation',
            'Rear Seat Entertainment System (available)',
            'Smart Power Sliding Doors',
            'Power Rear Liftgate',
            'Wireless Phone Charging',
            '8 USB Ports (throughout cabin)',
            '110V Power Inverter',
            'In-Cabin Intercom System',
            'Safe Exit Assist'
        ],
        comments: [
            {
                id: 1,
                image: images.car6Review1,
                name: 'David Thompson',
                date: 'June 10th, 2023',
                rating: 4.8,
                content: 'Took my family of 6 to Disney World - the Carnival swallowed all our luggage easily. Kids loved the built-in screens and USB ports everywhere!',
            },
            {
                id: 2,
                image: images.car6Review2,
                name: 'Lisa Park',
                date: 'September 3rd, 2023',
                rating: 4.7,
                content: 'The sliding doors were lifesavers in tight parking lots. So many clever storage spaces - we found new compartments even after a week of use!',
            }
        ],
    },
    {
        id: 7,
        name: 'Ford Mustang',
        image: images.car7Gallery1,
        price: 85,
        gallery: {
            image1: images.car7Gallery1,
            image2: images.car7Gallery2,
            image3: images.car7Gallery3,
            image4: images.car7Gallery4,
        },
        details: {
            year: 2021,
            brand: "Ford",
            type: "Coupe",
            fuelType: ["Petrol"],
            transmission: ["Automatic", "Manual"],
            costPerMile: "$2.8 per mile",
            availability: "All days",
            maxSpeed: "155 mph",
            power: "310 HP",
            range: "350 miles",
            climateControl: "Dual-Zone Automatic",
            safetyFeatures: "Stability Control, Tire Monitoring",
            colorOptions: "Red, White, Black, Blue",
            seats: "4 seats",
            suitcase: "2 medium suitcases",
        },
        description: 'The Ford Mustang delivers iconic American muscle with modern refinement. Choose between the turbocharged 2.3L EcoBoost (310HP) or thunderous 5.0L Coyote V8 (450HP), both offering spine-tingling exhaust notes through active valve performance exhaust. The driver-focused cockpit features customizable digital instruments and supportive Recaro seats. With selectable drive modes (Normal/Sport/Track/Snow+Wet) and available MagneRide damping, this pony car adapts to your driving style while turning heads everywhere.',
        additionalInfo: [
            '2.3L EcoBoost Turbo (310HP) or 5.0L V8 (450HP)',
            '10-Speed Auto or 6-Speed Manual (GT only)',
            'Rear-Wheel Drive with Limited-Slip Diff',
            '12-inch Digital Instrument Cluster',
            'Active Valve Performance Exhaust',
            'Selectable Drive Modes',
            'MagneRide Damping (available)',
            'SYNC 4 with 8-inch Touchscreen',
            'Ambient Lighting (64 colors)',
            'Heated/Cooled Seats (available)',
            'Ford Co-Pilot360 Safety Package'
        ],
        comments: [
            {
                id: 1,
                image: images.car7Review1,
                name: 'Jason Carter',
                date: 'July 4th, 2023',
                rating: 4.8,
                content: 'Rented the GT for a Route 66 trip - the V8 roar through the desert was unforgettable! Surprisingly comfortable for long drives too.',
            },
            {
                id: 2,
                image: images.car7Review2,
                name: 'Sophia Martinez',
                date: 'October 22nd, 2023',
                rating: 4.5,
                content: 'The EcoBoost had plenty of power for mountain roads and better gas mileage than expected. Got compliments everywhere we stopped!',
            }
        ],
    },
    {
        id: 8,
        name: 'Chevrolet Silverado',
        image: images.car8Gallery1,
        price: 75,
        gallery: {
            image1: images.car8Gallery1,
            image2: images.car8Gallery2,
            image3: images.car8Gallery3,
            image4: images.car8Gallery4,
        },
        details: {
            year: 2022,
            brand: "Chevrolet",
            type: "Truck",
            fuelType: ["Gasoline", "Diesel"],
            transmission: ["Automatic"],
            costPerMile: "$2.2 per mile",
            availability: "All days",
            maxSpeed: "110 mph",
            power: "355 HP (5.3L V8)",
            range: "500 miles",
            climateControl: "Dual-Zone Climate Control",
            safetyFeatures: "Airbags, ABS, Traction Control, Rearview Camera",
            colorOptions: "Black, White, Red, Blue",
            seats: "5 seats",
            suitcase: "4+ suitcase",
        },
        description: 'The Chevrolet Silverado combines rugged capability with modern comfort, featuring a powerful V8 engine and advanced towing technologies. Its spacious cabin offers premium materials and intuitive tech features, while the durable truck bed handles heavy loads with ease. Perfect for work sites or outdoor adventures, the Silverado delivers both strength and refinement on every journey.',
        additionalInfo: [
            '5.3L EcoTec3 V8 Engine',
            '10-Speed Automatic Transmission',
            '4-Wheel Drive Available',
            'Advanced Trailering System',
            'Multi-Flex Tailgate',
            'Chevrolet Infotainment 3 System',
            'Bose Premium Audio',
            'Heated Steering Wheel',
            'Wireless Phone Charging'
        ],
        comments: [
            {
                id: 1,
                image: images.car8Review1,
                name: 'Mike Thompson',
                date: 'March 12th, 2023',
                rating: 4.6,
                content: 'Handled all my construction materials with ease. The cabin is surprisingly quiet and comfortable for a work truck!',
            },
            {
                id: 2,
                image: images.car8Review2,
                name: 'Sarah Williams',
                date: 'August 5th, 2023',
                rating: 4.5,
                content: 'Towed our boat effortlessly on vacation. The trailering cameras made hooking up and backing down the ramp a breeze.',
            },
        ]
    },
    {
        id: 9,
        name: 'Honda Accord',
        image: images.car9Gallery1,
        price: 52,
        gallery: {
            image1: images.car9Gallery1,
            image2: images.car9Gallery2,
            image3: images.car9Gallery3,
            image4: images.car9Gallery4,
        },
        details: {
            year: 2023,
            brand: "Honda",
            type: "Sedan",
            fuelType: ["Petrol", "Hybrid"],
            transmission: ["Automatic"],
            costPerMile: "$1.7 per mile",
            availability: "All days",
            maxSpeed: "130 mph",
            power: "192 HP (1.5T), 252 HP (2.0T)",
            range: "460 miles",
            climateControl: "Dual-Zone Climate Control",
            safetyFeatures: "Airbags, ABS, Lane Assist",
            colorOptions: "Silver, White, Blue, Black",
            seats: "5 seats",
            suitcase: "2 suitcase",
        },
        description: 'The Honda Accord sets the benchmark for midsize sedans with its refined driving dynamics and premium interior. Featuring responsive turbocharged engine options and available hybrid efficiency, it delivers a perfect balance of performance and economy. The spacious cabin offers premium materials and intuitive technology, including the latest Honda Sensing safety suite. With its sleek styling and comfortable ride, the Accord excels for both daily commutes and long-distance travel.',
        additionalInfo: [
            '1.5L Turbo (192HP) or 2.0L Turbo (252HP)',
            'Available Hybrid Powertrain',
            'Honda Sensing Safety Suite',
            '7-inch Digital Instrument Cluster',
            '8-inch Touchscreen Display',
            'Apple CarPlay/Android Auto',
            'LED Headlights',
            'Heated Front Seats',
            'Wireless Charging'
        ],
        comments: [
            {
                id: 1,
                image: images.car9Review1,
                name: 'Robert Chen',
                date: 'January 18th, 2023',
                rating: 4.7,
                content: 'Fantastic all-around sedan. The turbo engine has plenty of power when needed, yet sips fuel during my daily commute.',
            },
            {
                id: 2,
                image: images.car9Review2,
                name: 'Jessica Kim',
                date: 'May 30th, 2023',
                rating: 4.8,
                content: 'Upgraded from an older Accord - the new interior feels like a luxury car. Honda Sensing gives me peace of mind on the highway.',
            },
        ]
    },
    {
        id: 10,
        name: 'Porsche 911 Cabriolet',
        image: images.car10Gallery1,
        price: 350,
        gallery: {
            image1: images.car10Gallery1,
            image2: images.car10Gallery2,
            image3: images.car10Gallery3,
            image4: images.car10Gallery4,
        },
        details: {
            year: 2024,
            brand: "Porsche",
            type: "Convertible",
            fuelType: ["Petrol"],
            transmission: ["Automatic", "Manual"],
            costPerMile: "$5.0 per mile",
            availability: "Weekends only",
            maxSpeed: "191 mph",
            power: "379 HP (Carrera S)",
            range: "320 miles",
            climateControl: "Dual-Zone Automatic",
            safetyFeatures: "Ceramic Brakes, Night Vision",
            colorOptions: "Red, Black, White, Silver",
            seats: "4 seats",
            suitcase: "1 medium suitcase",
        },
        description: 'The Porsche 911 Cabriolet combines legendary performance with open-top exhilaration. Its rear-mounted 3.0L twin-turbo flat-6 engine delivers explosive acceleration, while the lightweight retractable soft top transforms in seconds. The precision-tuned chassis and rear-wheel steering create telepathic handling, whether cruising coastal highways or attacking mountain passes. Luxurious interior finishes and cutting-edge Porsche Communication Management complete this iconic driving experience.',
        additionalInfo: [
            '3.0L Twin-Turbo Flat-6 Engine',
            '8-Speed PDK Dual-Clutch Transmission',
            'Rear-Wheel Drive (AWD available)',
            'Porsche Active Suspension Management',
            'Sport Chrono Package with Launch Control',
            '12.3-inch Porsche Digital Cluster',
            '10.9-inch Touchscreen Infotainment',
            'Bose Surround Sound System',
            'Heated/Ventilated 18-Way Seats',
            'Porsche Torque Vectoring',
            'Convertible Wind Deflector'
        ],
        comments: [
            {
                id: 1,
                image: images.car10Review1,
                name: 'Alexander Wagner',
                date: 'June 15th, 2023',
                rating: 5.0,
                content: "Absolute perfection! The sound of the flat-6 with the top down is intoxicating. Handles like it's on rails - worth every penny for my anniversary trip.",
            },
            {
                id: 2,
                image: images.car10Review2,
                name: 'Olivia Bennett',
                date: 'September 2nd, 2023',
                rating: 4.9,
                content: 'Rented this for a weekend getaway - the perfect balance of luxury and raw performance. The PDK transmission shifts faster than I can blink!',
            }
        ],
    },
    {
        id: 11,
        name: 'Jeep Grand Cherokee',
        image: images.car11Gallery1,
        price: 90,
        gallery: {
            image1: images.car11Gallery1,
            image2: images.car11Gallery2,
            image3: images.car11Gallery3,
            image4: images.car11Gallery4,
        },
        details: {
            year: 2025,
            brand: "Jeep",
            type: "SUV",
            fuelType: ["Petrol", "Diesel", "Hybrid"],
            transmission: ["Automatic"],
            costPerMile: "$2.3 per mile",
            availability: "All days",
            maxSpeed: "130 mph",
            power: "293 HP (V6), 357 HP (V8), 375 HP (Hybrid)",
            range: "450 miles (Petrol), 550 miles (Diesel)",
            climateControl: "Tri-Zone Auto",
            safetyFeatures: "7 Airbags, Adaptive Cruise, Blind Spot, ParkSense Assist",
            colorOptions: "White, Red, Crystal, Black",
            seats: "5 (7-seat L option)",
            suitcase: "4 large suitcases",
        },
        description: 'The Jeep Grand Cherokee delivers premium on-road refinement with legendary off-road capability. Its available Quadra-Trac II 4x4 system and Quadra-Lift air suspension conquer any terrain, while the luxurious interior features premium leather and cutting-edge Uconnect technology. Perfect for both family road trips and adventurous getaways, the Grand Cherokee offers commanding views of the road with seating for up to seven in available L models. The available 5.7L HEMI® V8 delivers exhilarating power, while the 4xe plug-in hybrid combines efficiency with Jeep capability.',
        additionalInfo: [
            '3.6L Pentastar V6 (293HP) or 5.7L HEMI V8 (357HP)',
            'Available 4xe Plug-in Hybrid (375HP combined)',
            'Quadra-Trac II 4WD System',
            'Quadra-Lift Air Suspension (available)',
            '10.1-inch Uconnect Touchscreen',
            '19-speaker McIntosh Audio System',
            'Panoramic Sunroof',
            'Heated/Ventilated Front Seats',
            'Heated Second-Row Seats',
            'Hands-free Power Liftgate',
            'Trailer Tow Package (up to 7,200 lbs)'
        ],
        comments: [
            {
                id: 1,
                image: images.car11Review1,
                name: 'Michael Anderson',
                date: 'April 5th, 2023',
                rating: 4.7,
                content: 'Took this through mountain trails and it handled everything effortlessly. The air suspension made rough roads feel smooth!',
            },
            {
                id: 2,
                image: images.car11Review2,
                name: 'Jennifer Lee',
                date: 'August 19th, 2023',
                rating: 4.6,
                content: 'Loved the premium interior - doesn\'t feel like an SUV. The hybrid version gave us great mileage on our cross-country trip.',
            }
        ],
    },
    {
        id: 12,
        name: 'Hyundai i30',
        image: images.car12Gallery1,
        price: 45,
        gallery: {
            image1: images.car12Gallery1,
            image2: images.car12Gallery2,
            image3: images.car12Gallery3,
            image4: images.car12Gallery4,
        },
        details: {
            year: 2019,
            brand: "Hyundai",
            type: "Hatchback",
            fuelType: ["Petrol", "Diesel"],
            transmission: ["Manual", "Automatic"],
            costPerMile: "$1.5 per mile",
            availability: "All days",
            maxSpeed: "130 mph (varies by engine)",
            power: "120 HP (1.4L), 201 HP (N Line)",
            range: "480 miles (Petrol), 600 miles (Diesel)",
            climateControl: "Single-Zone Auto",
            safetyFeatures: "Airbags, ABS, ESC, Lane Assist",
            colorOptions: "Black, White, Red, Silver",
            seats: "5 seats",
            suitcase: "2 large suitcases",
        },
        description: 'The Hyundai i30 combines European-inspired handling with Korean value in a practical hatchback package. Its efficient engines deliver peppy urban performance while maintaining excellent fuel economy, and the well-tuned suspension strikes a perfect balance between comfort and agility. The modern interior features intuitive controls and generous standard tech, including smartphone integration. With its versatile cargo space and compact dimensions, the i30 is ideal for both city commuting and weekend adventures.',
        additionalInfo: [
            '1.4L Turbo GDI (120HP) or 1.6L CRDi (136HP)',
            'Available N Line Sport Package (201HP)',
            '7-inch Digital Instrument Cluster',
            '10.25-inch Touchscreen Navigation',
            'Apple CarPlay/Android Auto',
            'Wireless Phone Charging',
            'LED Headlights and Taillights',
            'Heated Front Seats',
            'Rear View Camera',
            'Hyundai SmartSense Safety Suite'
        ],
        comments: [
            {
                id: 1,
                image: images.car12Review1,
                name: 'Thomas Müller',
                date: 'March 15th, 2023',
                rating: 4.5,
                content: 'Perfect city car - easy to park yet surprisingly spacious inside. The turbo engine has great low-end torque for stop-and-go traffic.',
            },
            {
                id: 2,
                image: images.car12Review2,
                name: 'Sophie Laurent',
                date: 'July 22nd, 2023',
                rating: 4.6,
                content: 'Drove the diesel version across Europe - averaged 60mpg! The infotainment system was incredibly easy to use in every country.',
            }
        ],
    },
    {
        id: 13,
        name: 'Chevrolet Corvette',
        image: images.car13Gallery1,
        price: 300,
        gallery: {
            image1: images.car13Gallery1,
            image2: images.car13Gallery2,
            image3: images.car13Gallery3,
            image4: images.car13Gallery4,
        },
        details: {
            year: 2020,
            brand: "Chevrolet",
            type: "Sports Car",
            fuelType: ["Petrol"],
            transmission: ["Automatic"],
            costPerMile: "$4.5 per mile",
            availability: "Weekends only",
            maxSpeed: "194 mph",
            power: "495 HP (Stingray), 670 HP (Z06)",
            range: "290 miles",
            climateControl: "Dual-Zone Automatic",
            safetyFeatures: "Traction Management, Limited-Slip Differential, Front Lift",
            colorOptions: "Red, White, Black, Blue",
            seats: "2 seats",
            suitcase: "1 large suitcase",
        },
        description: 'The mid-engine Chevrolet Corvette Stingray redefines American performance with exotic car capabilities at a fraction of the cost. Its 6.2L LT2 V8 produces 495HP and rockets to 60mph in 2.9 seconds when equipped with Z51 package, while the revolutionary mid-engine layout provides perfect weight distribution. The fighter jet-inspired cockpit features premium materials and a driver-focused layout, with every control perfectly positioned. This is the most capable and technologically advanced Corvette ever built - a true world-class supercar with American muscle roots.',
        additionalInfo: [
            '6.2L LT2 V8 Engine (495HP/470 lb-ft)',
            '8-Speed Tremec Dual-Clutch Transmission',
            'Mid-Engine Layout',
            '12-inch Digital Instrument Cluster',
            'Performance Data Recorder',
            'Magnetic Ride Control 4.0',
            'Z51 Performance Package Available',
            'Bose Performance Series Audio',
            'Heated/Ventilated GT2 Seats',
            'Front Lift System (2-inch clearance)',
            'Track Mode with Performance Traction Management'
        ],
        comments: [
            {
                id: 1,
                image: images.car13Review1,
                name: 'James Wilson',
                date: 'May 30th, 2023',
                rating: 5.0,
                content: 'The mid-engine transformation is incredible - handles like a Ferrari at a Chevy price! The exhaust note under acceleration is pure American muscle.',
            },
            {
                id: 2,
                image: images.car13Review2,
                name: 'Lisa Park',
                date: 'August 17th, 2023',
                rating: 4.9,
                content: 'Rented this for my husband\'s 40th birthday. The acceleration is brutal yet controllable. Surprisingly comfortable for a supercar - we did 300 miles without fatigue!',
            }
        ],
    },
    {
        id: 14,
        name: 'Toyota Sienna',
        image: images.car14Gallery1,
        price: 65,
        gallery: {
            image1: images.car14Gallery1,
            image2: images.car14Gallery2,
            image3: images.car14Gallery3,
            image4: images.car14Gallery4,
        },
        details: {
            year: 2021,
            brand: "Toyota",
            type: "Minivan",
            fuelType: ["Hybrid"],
            transmission: ["Automatic"],
            costPerMile: "$1.6 per mile",
            availability: "All days",
            maxSpeed: "112 mph",
            power: "245 HP",
            range: "600 miles",
            climateControl: "Tri-Zone Automatic",
            safetyFeatures: "10 Airbags, Blind Spot Monitor",
            colorOptions: "Celestial Silver, Ruby Flare, Black",
            seats: "7-8 seats",
            suitcase: "5-7 suitcases",
        },
        description: 'The Toyota Sienna redefines family travel with its standard hybrid powertrain delivering exceptional fuel economy without sacrificing space or comfort. Its versatile interior features available second-row lounge seats with leg extensions, while the all-wheel drive option provides confidence in all weather conditions. Packed with family-friendly tech like rear seat entertainment and a built-in vacuum, the Sienna makes every journey comfortable and convenient. The ultra-quiet hybrid powertrain and smooth ride quality ensure relaxed travel for all passengers.',
        additionalInfo: [
            '2.5L 4-cylinder Hybrid (245HP combined)',
            'Standard Electronic On-Demand AWD',
            'Toyota Safety Sense 2.0',
            '12-speaker JBL Premium Audio',
            'Rear Seat Entertainment System',
            '1500W AC Power Inverter',
            'Built-in Vacuum Cleaner (available)',
            '18-inch Alloy Wheels',
            'Power Sliding Doors',
            'Hands-Free Power Liftgate',
            'Digital Rearview Mirror',
            'Wireless Charging'
        ],
        comments: [
            {
                id: 1,
                image: images.car14Review1,
                name: 'David Kim',
                date: 'June 12th, 2023',
                rating: 4.8,
                content: 'Took our family of 5 on a cross-country trip - averaged 36mpg even fully loaded! The kids loved the built-in entertainment system.',
            },
            {
                id: 2,
                image: images.car14Review2,
                name: 'Maria Garcia',
                date: 'September 5th, 2023',
                rating: 4.7,
                content: 'The hybrid system is so smooth and quiet. We fit everything for our beach vacation easily - strollers, coolers, and all!',
            }
        ],
    },
    {
        id: 15,
        name: 'Mercedes-Benz E-Class Coupe',
        image: images.car15Gallery1,
        price: 180,
        gallery: {
            image1: images.car15Gallery1,
            image2: images.car15Gallery2,
            image3: images.car15Gallery3,
            image4: images.car15Gallery4,
        },
        details: {
            year: 2022,
            brand: "Mercedes-Benz",
            type: "Coupe",
            fuelType: ["Petrol", "Diesel", "Hybrid"],
            transmission: ["Automatic"],
            costPerMile: "$3.5 per mile",
            availability: "All days",
            maxSpeed: "155 mph (electronically limited)",
            power: "255 HP (E 350), 362 HP (E 450)",
            range: "450 miles (petrol)",
            climateControl: "Thermotronic 3-Zone",
            safetyFeatures: "PRE-SAFE, Brake Assist",
            colorOptions: "Black, White, Grey, Red",
            seats: "4 seats",
            suitcase: "2 large suitcases",
        },
        description: 'The Mercedes-Benz E-Class Coupe combines breathtaking design with cutting-edge technology in a luxurious grand touring package. Its sweeping silhouette and frameless doors exude sophistication, while the powerful turbocharged engines deliver effortless acceleration. The cabin showcases handcrafted materials, ambient lighting with 64 colors, and the latest MBUX infotainment system. With its AIRMATIC suspension and refined powertrain, this coupe transforms every drive into a special occasion while maintaining surprising practicality for a 2+2 configuration.',
        additionalInfo: [
            '2.0L Turbo I4 (E 350) or 3.0L Turbo I6 (E 450)',
            '9G-TRONIC Automatic Transmission',
            'Rear-Wheel Drive (4MATIC AWD available)',
            'MBUX Augmented Video Navigation',
            '12.3-inch Digital Instrument Cluster',
            '12.3-inch Central Media Display',
            'Burmester Surround Sound System',
            'AIRMATIC Air Suspension',
            'Energizing Comfort Control',
            'Multicontour Seats with Massage',
            'Keyless-Go Comfort Package'
        ],
        comments: [
            {
                id: 1,
                image: images.car15Review1,
                name: 'Alexander von Sternberg',
                date: 'July 8th, 2023',
                rating: 4.9,
                content: "The perfect blend of luxury and performance. The E 450's inline-6 is buttery smooth yet powerful when needed. The interior makes you feel special every time.",
            },
            {
                id: 2,
                image: images.car15Review2,
                name: 'Sophie Laurent',
                date: 'October 15th, 2023',
                rating: 4.8,
                content: 'Rented this for our anniversary weekend - the ambient lighting and premium sound system created an incredible atmosphere. Surprisingly practical trunk space too!',
            }
        ],
    },
    {
        id: 16,
        name: 'Toyota Tacoma',
        image: images.car16Gallery1,
        price: 80,
        gallery: {
            image1: images.car16Gallery1,
            image2: images.car16Gallery2,
            image3: images.car16Gallery3,
            image4: images.car16Gallery4,
        },
        details: {
            year: 2023,
            brand: "Toyota",
            type: "Truck",
            fuelType: ["Gasoline"],
            transmission: ["Automatic", "Manual"],
            costPerMile: "$2.0 per mile",
            availability: "All days",
            maxSpeed: "110 mph",
            power: "278 HP (V6), 159 HP (4-cylinder)",
            range: "400 miles (V6)",
            climateControl: "Dual-Zone Automatic",
            safetyFeatures: "Toyota Safety Sense, Airbags, ABS",
            colorOptions: "Green, Gray, Black, White",
            seats: "5 seats",
            suitcase: "4+ suitcases",
        },
        description: 'The Toyota Tacoma is the ultimate adventure-ready mid-size truck, combining legendary reliability with serious off-road capability. Its rugged body-on-frame construction and available TRD Off-Road package with Crawl Control tackle the toughest trails, while the comfortable interior features modern tech for daily driving. Perfect for contractors or outdoor enthusiasts, the Tacoma offers a 6,800 lb towing capacity and versatile bed utility with available 120V outlet. The proven 3.5L V6 delivers confident power whether you\'re hauling gear or exploring backcountry roads.',
        additionalInfo: [
            '3.5L V6 (278HP/265 lb-ft) or 2.7L 4-cylinder (159HP)',
            'Part-Time 4WD with Low Range (available)',
            'TRD Off-Road Package (available)',
            'Multi-Terrain Select & Crawl Control',
            '8-inch Touchscreen with Apple CarPlay',
            'Qi Wireless Charging',
            'Power Tilt/Slide Moonroof',
            'Towing Package (up to 6,800 lbs)',
            'Bed 120V/400W Outlet',
            'LED Headlights',
            'Toyota Safety Sense P'
        ],
        comments: [
            {
                id: 1,
                image: images.car16Review1,
                name: 'Ryan Mitchell',
                date: 'May 20th, 2023',
                rating: 4.7,
                content: 'Took this through Moab and it handled everything like a champ! The Crawl Control made technical sections a breeze. Perfect adventure vehicle.',
            },
            {
                id: 2,
                image: images.car16Review2,
                name: 'Jessica Wong',
                date: 'August 15th, 2023',
                rating: 4.5,
                content: 'Used the Tacoma for both my landscaping business and weekend camping trips. The bed utility features saved me so much time on job sites.',
            }
        ],
    },
    {
        id: 17,
        name: 'GMC Sierra 1500',
        image: images.car17Gallery1,
        price: 110,
        gallery: {
            image1: images.car17Gallery1,
            image2: images.car17Gallery2,
            image3: images.car17Gallery3,
            image4: images.car17Gallery4,
        },
        details: {
            year: 2024,
            brand: "GMC",
            type: "Truck",
            fuelType: ["Gasoline", "Diesel", "Hybrid"],
            transmission: ["Automatic"],
            costPerMile: "$2.5 per mile",
            availability: "All days",
            maxSpeed: "115 mph",
            power: "355-420 HP (V8), 277 HP (Diesel)",
            range: "500 miles (gas), 700+ miles (diesel)",
            climateControl: "Tri-Zone",
            safetyFeatures: "GMC Pro Safety, 10 Airbags, HD Vision",
            colorOptions: "Titanium, Redwood, Black, White",
            seats: "5-6 seats",
            suitcase: "4+ suitcases",
        },
        description: 'The GMC Sierra 1500 redefines premium capability with its innovative MultiPro Tailgate and segment-first features. Choose between potent V8 power or torque-rich turbo-diesel efficiency, all wrapped in GMC\'s professional-grade luxury. The available Denali trim elevates the experience with handcrafted interiors and cutting-edge technology, while the CarbonPro bed offers unmatched durability. Whether towing up to 13,400 lbs or navigating city streets, the Sierra balances work-ready toughness with refined comfort through its Magnetic Ride Control suspension.',
        additionalInfo: [
            'Available 6.2L V8 (420HP/460 lb-ft) or 3.0L Turbo-Diesel (277HP/460 lb-ft)',
            '10-Speed Automatic Transmission',
            'MultiPro Tailgate with 6 Functions',
            'CarbonPro Composite Bed (available)',
            '15-inch Head-Up Display',
            '12.3-inch Digital Instrument Cluster',
            '14-inch Infotainment Touchscreen',
            'Bose Premium Sound System',
            'Magnetic Ride Control (available)',
            'Trailering Package with Camera System',
            'Power Retractable Assist Steps',
            'Wireless Apple CarPlay/Android Auto'
        ],
        comments: [
            {
                id: 1,
                image: images.car17Review1,
                name: 'Michael Johnson',
                date: 'June 18th, 2023',
                rating: 4.8,
                content: 'The MultiPro Tailgate is a game-changer - used all six positions on my construction site last week. The diesel torque makes towing feel effortless!',
            },
            {
                id: 2,
                image: images.car17Review2,
                name: 'Sarah Williams',
                date: 'September 5th, 2023',
                rating: 4.9,
                content: 'Rented the Denali for a family move - luxurious enough to feel special yet hauled all our furniture. The surround-view cameras made parking this big truck surprisingly easy.',
            }
        ],
    },
    {
        id: 18,
        name: 'BMW 3 Series',
        image: images.car18Gallery1,
        price: 95,
        gallery: {
            image1: images.car18Gallery1,
            image2: images.car18Gallery2,
            image3: images.car18Gallery3,
            image4: images.car18Gallery4,
        },
        details: {
            year: 2025,
            brand: "BMW",
            type: "Sedan",
            fuelType: ["Petrol", "Diesel", "Hybrid"],
            transmission: ["Automatic"],
            costPerMile: "$2.8 per mile",
            availability: "All days",
            maxSpeed: "155 mph",
            power: "255 HP (330i), 382 HP (M340i)",
            range: "450 miles",
            climateControl: "Dual-Zone Automatic",
            safetyFeatures: "Driving Assistant, Airbags, ABS",
            colorOptions: "White, Black, Blue, Orange",
            seats: "5 seats",
            suitcase: "1.5 large suitcase",
        },
        description: 'The BMW 3 Series defines the sports sedan segment with perfect 50/50 weight distribution and rear-wheel-drive dynamics. Its turbocharged engines deliver immediate response, while the precise steering and balanced chassis provide unmatched driving pleasure. The sophisticated interior features premium materials and the latest iDrive 7 technology, including intelligent voice control. Whether navigating city streets or mountain passes, the 3 Series offers the ideal blend of luxury, technology, and driving excitement that BMW is famous for.',
        additionalInfo: [
            '2.0L Turbo I4 (255HP) or 3.0L Turbo I6 (382HP in M340i)',
            '8-Speed Sport Automatic Transmission',
            'Rear-Wheel Drive (xDrive AWD available)',
            'Live Cockpit Professional with 12.3" Display',
            '10.25" Central Touchscreen',
            'BMW Intelligent Personal Assistant',
            'Harman Kardon Surround Sound',
            'Adaptive M Suspension (available)',
            'Heated Front Seats',
            'Ambient Lighting',
            'Wireless Charging'
        ],
        comments: [
            {
                id: 1,
                image: images.car18Review1,
                name: 'Daniel Schmidt',
                date: 'April 15th, 2023',
                rating: 4.8,
                content: 'The perfect balance of luxury and sportiness. The steering feedback is telepathic, and the turbo power comes on strong. Feels special every time I drive it.',
            },
            {
                id: 2,
                image: images.car18Review2,
                name: 'Emily Chen',
                date: 'July 22nd, 2023',
                rating: 4.7,
                content: 'Rented the 330i for a business trip - impressed with both the fuel economy and performance. The tech interface is intuitive once you learn the iDrive system.',
            }
        ],
    },
    {
        id: 19,
        name: 'Chevrolet Camaro Convertible',
        image: images.car19Gallery1,
        price: 150,
        gallery: {
            image1: images.car19Gallery1,
            image2: images.car19Gallery2,
            image3: images.car19Gallery3,
            image4: images.car19Gallery4,
        },
        details: {
            year: 2019,
            brand: "Chevrolet",
            type: "Convertible",
            fuelType: ["Petrol"],
            transmission: ["Manual", "Automatic"],
            costPerMile: "$3.5 per mile",
            availability: "All days",
            maxSpeed: "165 mph",
            power: "275 HP (Turbo), 455 HP (V8 SS)",
            range: "300 miles",
            climateControl: "Dual-Zone",
            safetyFeatures: "Stability Control, Airbags, Rear Camera",
            colorOptions: "Blue, White, Red, Shock",
            seats: "4 seats",
            suitcase: "1 medium suitcase",
        },
        description: 'The Chevrolet Camaro Convertible delivers classic American muscle car thrills with open-air freedom. Its power-folding soft top retracts in seconds, revealing a symphony of V8 exhaust notes from the available 6.2L LT1 engine. The driver-focused cockpit features a configurable digital gauge cluster and heads-up display, while Magnetic Ride Control (available) ensures precise handling whether cruising coastal highways or attacking canyon roads. With its aggressive styling and exhilarating performance, this drop-top Camaro turns every drive into an event.',
        additionalInfo: [
            '2.0L Turbo (275HP) or 6.2L V8 (455HP in SS)',
            'Available 6-speed manual transmission',
            'Power-folding insulated soft top',
            'Dual-Mode Performance Exhaust (SS)',
            '8-inch Digital Instrument Cluster',
            'Heads-Up Display',
            'Bose Premium Audio',
            'Heated/Ventilated Front Seats',
            'Wireless Charging',
            'Magnetic Ride Control (available)',
            'Launch Control (SS models)'
        ],
        comments: [
            {
                id: 1,
                image: images.car19Review1,
                name: 'Jason Miller',
                date: 'June 10th, 2023',
                rating: 4.8,
                content: 'Rented the SS convertible for a weekend - the V8 roar with the top down is absolutely intoxicating! The magnetic suspension makes it surprisingly comfortable too.',
            },
            {
                id: 2,
                image: images.car19Review2,
                name: 'Sophia Rodriguez',
                date: 'August 5th, 2023',
                rating: 4.6,
                content: 'The turbo model had plenty of power for mountain roads and better fuel economy than expected. Got compliments everywhere we went with the top down!',
            }
        ],
    },
    {
        id: 20,
        name: 'Toyota RAV4',
        image: images.car20Gallery1,
        price: 65,
        gallery: {
            image1: images.car20Gallery1,
            image2: images.car20Gallery2,
            image3: images.car20Gallery3,
            image4: images.car20Gallery4,
        },
        details: {
            year: 2020,
            brand: "Toyota",
            type: "SUV",
            fuelType: ["Gasoline", "Hybrid"],
            transmission: ["Automatic"],
            costPerMile: "$1.8 per mile",
            availability: "All days",
            maxSpeed: "120 mph",
            power: "203-302 HP",
            range: "500-580 miles",
            climateControl: "Dual-Zone",
            safetyFeatures: "TSS 2.0, 8 Airbags, Blind Spot",
            colorOptions: "Blueprint, Ruby, Gray, White",
            seats: "5 seats",
            suitcase: "3 large suitcases",
        },
        description: 'The Toyota RAV4 combines rugged SUV styling with exceptional efficiency, offering available hybrid and plug-in hybrid powertrains without compromising capability. Its comfortable interior features premium materials and intuitive technology, while the available Adventure grade adds off-road enhancements like Multi-Terrain Select. Perfect for both city commuting and weekend getaways, the RAV4 delivers Toyota reliability with available all-weather confidence through Dynamic Torque Vectoring AWD. The spacious cabin and generous cargo area make it ideal for families and adventurers alike.',
        additionalInfo: [
            '2.5L 4-cylinder (203HP) or Hybrid (219HP combined)',
            'Available Plug-in Hybrid (302HP combined)',
            'Dynamic Torque Vectoring AWD (available)',
            'Toyota Safety Sense 2.0',
            '8-inch Touchscreen with Apple CarPlay',
            '7-inch Multi-Information Display',
            'Power Liftgate',
            'Heated Front Seats',
            'Qi Wireless Charging',
            'Multi-Terrain Select (Adventure grade)',
            '120V/1500W Power Outlet (Adventure)'
        ],
        comments: [
            {
                id: 1,
                image: images.car20Review1,
                name: 'David Kim',
                date: 'March 15th, 2023',
                rating: 4.7,
                content: 'The hybrid version gave us 42 mpg on our road trip while still having plenty of power for mountain passes. The cargo space swallowed all our camping gear!',
            },
            {
                id: 2,
                image: images.car20Review2,
                name: 'Lisa Thompson',
                date: 'July 8th, 2023',
                rating: 4.6,
                content: 'Perfect family SUV - easy to park in the city yet capable enough for light trails. The safety features give me peace of mind with kids onboard.',
            }
        ],
    },
    {
        id: 21,
        name: 'Ford Focus Hatchback',
        image: images.car21Gallery1,
        price: 48,
        gallery: {
            image1: images.car21Gallery1,
            image2: images.car21Gallery2,
            image3: images.car21Gallery3,
            image4: images.car21Gallery4,
        },
        details: {
            year: 2021,
            brand: "Ford",
            type: "Hatchback",
            fuelType: ["Gasoline"],
            transmission: ["Automatic"],
            costPerMile: "$1.6 per mile",
            availability: "All days",
            maxSpeed: "125 mph",
            power: "160 HP (2.0L), 250 HP (ST)",
            range: "430 miles",
            climateControl: "Single-Zone",
            safetyFeatures: "Co-Pilot360, Airbags, ABS",
            colorOptions: "Red, Gray, White, Blue",
            seats: "5 seats",
            suitcase: "2 large suitcases",
        },
        description: 'The Ford Focus Hatchback delivers European-inspired handling in a practical, fuel-efficient package. Its responsive 2.0L engine and torque-vectoring control provide surprising agility, while the sleek hatchback design offers versatile cargo space. The cabin features intuitive SYNC 3 technology and available premium materials, making it ideal for both daily commutes and weekend adventures. With its tight turning radius and compact dimensions, the Focus excels in urban environments while maintaining highway comfort.',
        additionalInfo: [
            '2.0L Ti-VCT I4 Engine (160HP)',
            '8-Speed Automatic Transmission',
            'Front-Wheel Drive',
            'SYNC 3 with 8-inch Touchscreen',
            'Apple CarPlay/Android Auto',
            'B&O Premium Audio (available)',
            'Heated Front Seats (available)',
            'LED Signature Lighting',
            'Ford Co-Pilot360 Assist+',
            'QuickClear Heated Windshield'
        ],
        comments: [
            {
                id: 1,
                image: images.car21Review1,
                name: 'Ryan Chen',
                date: 'April 10th, 2023',
                rating: 4.5,
                content: 'Perfect city car - zippy acceleration and easy to park. The hatchback swallowed my bike with seats folded. Averaged 34 mpg in mixed driving!',
            },
            {
                id: 2,
                image: images.car21Review1,
                name: 'Emma Wilson',
                date: 'August 5th, 2023',
                rating: 4.4,
                content: 'The handling is fantastic for a compact car. Took it on mountain roads and it felt planted in every corner. SYNC system is very user-friendly.',
            }
        ],
    },
    {
        id: 22,
        name: 'Porsche 718 Cayman',
        image: images.car22Gallery1,
        price: 280,
        gallery: {
            image1: images.car22Gallery1,
            image2: images.car22Gallery2,
            image3: images.car22Gallery3,
            image4: images.car22Gallery4,
        },
        details: {
            year: 2022,
            brand: "Porsche",
            type: "Sports Car",
            fuelType: ["Petrol"],
            transmission: ["Manual", "Automatic"],
            costPerMile: "$4.8 per mile",
            availability: "Weekends only",
            maxSpeed: "170-177 mph",
            power: "300-394 HP",
            range: "310 miles",
            climateControl: "Dual-Zone",
            safetyFeatures: "Porsche Stability, Ceramic Brakes, Tire Monitoring",
            colorOptions: "Red, Silver, Black, Yellow",
            seats: "2",
            suitcase: "1 large, 1 small",
        },
        description: 'The Porsche 718 Cayman represents the purest expression of mid-engine balance, with its flat-6 engine (or turbocharged flat-4 in newer models) positioned perfectly between the axles for sublime handling. The direct steering and low center of gravity create telepathic road connection, while the active aerodynamics optimize stability at high speeds. The driver-focused cockpit features premium materials and a configurable digital display, making every drive an event. This is a sports car that rewards skilled drivers yet remains surprisingly practical with its dual-trunk storage.',
        additionalInfo: [
            '2.0L Turbo Flat-4 (300HP) or 2.5L Turbo Flat-4 (350HP)',
            'Available 4.0L Flat-6 (394HP in GTS)',
            'Porsche Active Suspension Management (available)',
            'Sport Chrono Package with Launch Control',
            '20-inch Carrera S Wheels',
            'Porsche Torque Vectoring',
            '14-way Power Sport Seats',
            'Bose Surround Sound System',
            'Porsche Track Precision App',
            'Active Sport Exhaust (available)'
        ],
        comments: [
            {
                id: 1,
                image: images.car22Review1,
                name: 'Michael Schaffer',
                date: 'May 15th, 2023',
                rating: 4.9,
                content: 'The mid-engine balance is perfection - it rotates exactly how you want in corners. The manual transmission has the best shift action Ive ever experienced.',
            },
            {
                id: 2,
                image: images.car22Review1,
                name: 'Sophie Laurent',
                date: 'September 2nd, 2023',
                rating: 4.8,
                content: 'Rented the GTS for track day - the most predictable and rewarding car Ive driven at the limit. Surprisingly usable trunks fit all our weekend gear!',
            }
        ],
    },

];

export default cars;